// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AiAnalysisController from "./ai_analysis_controller"
application.register("ai-analysis", AiAnalysisController)

import AuditProgressController from "./audit_progress_controller"
application.register("audit-progress", AuditProgressController)

import CrawlProgressController from "./crawl_progress_controller"
application.register("crawl-progress", CrawlProgressController)

import DashboardMetricsController from "./dashboard_metrics_controller"
application.register("dashboard-metrics", DashboardMetricsController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import LandingTrackerController from "./landing_tracker_controller"
application.register("landing-tracker", LandingTrackerController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import PricingToggleController from "./pricing_toggle_controller"
application.register("pricing-toggle", PricingToggleController)

import SubscriptionRefreshController from "./subscription_refresh_controller"
application.register("subscription-refresh", SubscriptionRefreshController)

import ScheduleBuilderController from "./schedule_builder_controller"
application.register("schedule-builder", ScheduleBuilderController)

import TimezoneController from "./timezone_controller"
application.register("timezone", TimezoneController)

import CronPresetsController from "./cron_presets_controller"
application.register("cron-presets", CronPresetsController)

import AdminUpdatesController from "./admin_updates_controller"
application.register("admin-updates", AdminUpdatesController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModalOpenerController from "./modal_opener_controller"
application.register("modal-opener", ModalOpenerController)

import FixEditorController from "./fix_editor_controller"
application.register("fix-editor", FixEditorController)

import FixBulkController from "./fix_bulk_controller"
application.register("fix-bulk", FixBulkController)

import ConsoleController from "./console_controller"
application.register("console", ConsoleController)

import TableFilterController from "./table_filter_controller"
application.register("table-filter", TableFilterController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)
